<template>
  <div>
    <v-card-text>
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <ag-grid-vue
        style="width: 100%; padding: 5px"
        class="ag-theme-balham mt-2 mb-4"
        domLayout="autoHeight"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :frameworkComponents="frameworkComponents"
        :rowData="rows"
        pagination
        :paginationPageSize="10"
      ></ag-grid-vue>
      <v-card-actions class="pr-3 pb-3">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="show = true">Add User Permission</v-btn>
      </v-card-actions>
    </v-card-text>
    <PermissionDialog
      ref="userPermissionDialog"
      :show="show"
      @hide="hideUpdateDialog"
      @save="save"
      @remove="remove"
    />
    <InProgress :orderProgress="loading" />
  </div>
</template>
<script>
import globalMixin from '@/mixins/globalMixin';
import PermissionLevel from './user-permissions/permissions-select.vue';
import PermissionDialog from './user-permissions/user-permission-dialog.vue';
import ActionButtons from './user-permissions/action-buttons.vue';
import { AgGridVue } from 'ag-grid-vue';
import { createNamespacedHelpers } from 'vuex';
import { mapUserPermissionsFields } from '@/store/modules/userPermissions';
import { UserPermission } from '@/models/UserPermission';
import InProgress from '../mia/in-progress.vue';
const { mapActions: mapUserPermissionsActions } =
  createNamespacedHelpers(`userPermissions`);
export default {
  mixins: [globalMixin],
  components: {
    AgGridVue,
    PermissionLevel,
    PermissionDialog,
    ActionButtons,
    InProgress,
  },
  beforeMount() {
    let vm = this;
    let { remove, beforeUpdate } = vm;
    vm.gridOptions = {};
    vm.frameworkComponents = {
      permissionLevel: PermissionLevel,
      actionButtons: ActionButtons,
    };
    vm.defaultColDef = {
      autoHeight: true,
    };
    vm.columnDefs = [
      {
        headerName: 'Application',
        sortable: true,
        field: 'application',
        suppressSizeToFit: true,
      },

      {
        headerName: 'Email',
        sortable: false,
        field: 'email',
      },
      {
        headerName: 'Company',
        field: 'company',
        filter: true,
      },
      {
        headerName: 'Permission Group',
        field: 'permissionGroupDescription',
        suppressSizeToFit: true,
      },
      {
        headerName: 'Action',
        cellRenderer: 'actionButtons',
        suppressSizeToFit: true,
        cellRendererParams: {
          onUpdate: beforeUpdate,
          onDelete: remove,
        },
      },
    ];
  },
  mounted() {
    const vm = this;
    vm.loading = true;
    vm.getUserPermissions()
      .then(() => (vm.loading = false))
      .catch(() => (vm.loading = false));
  },
  data() {
    return {
      loading: false,
      show: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: {
        resizable: false,
      },
      search: '',
      gridApi: null,
      frameworkComponents: null,
    };
  },
  computed: {
    ...mapUserPermissionsFields(['message', 'rows']),
    filteredRows() {
      let { search, rows } = this;
      return rows.filter(
        ({ application, email, company, permissionGroupDescription }) => {
          return (
            search === '' ||
            (company && application.toLowerCase().includes(search)) ||
            (company && email.toLowerCase().includes(search)) ||
            (company && company.toLowerCase().includes(search)) ||
            (company &&
              permissionGroupDescription.toLowerCase().includes(search))
          );
        }
      );
    },
  },
  methods: {
    ...mapUserPermissionsActions([
      'getUserPermissions',
      'removeUserPermission',
      'updateUserPermissions',
    ]),
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
    },
    hideUpdateDialog() {
      this.$refs.userPermissionDialog.userPermission = new UserPermission();
      this.show = false;
    },
    save(data) {
      let vm = this;
      let payload = new UserPermission(data);
      vm.loading = true;
      vm.updateUserPermissions(payload).then((data) => {
        vm.hideUpdateDialog();
        vm.loading = false;
      });
    },
    beforeUpdate(data) {
      this.$refs.userPermissionDialog.userPermission = new UserPermission(data);
      this.show = true;
    },
    remove(data) {
      let vm = this;
      if (confirm('Remove user permission?')) {
        vm.loading = true;
        vm.removeUserPermission(data)
          .then((res) => {
            vm.loading = false;
            vm.hideUpdateDialog();
          })
          .catch((err) => {
            vm.loading = true;
            vm.hideUpdateDialog();
          });
      }
    },
  },
  watch: {
    search(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
